import { Message } from "@mui/icons-material"
import "./style.scss"

export default function AiTeammateNoMessage() {
  return <div className="no-message">
    <Message />
    <div className="title">Start a conversation</div>
    <div className="subtitle">Ask me about your portfolio data or request visualizations</div>
  </div>
}
